import React from "react";
import RuleRow from "./RuleRow";

function RuleTable({ rows, onOpenRule }) {
  return (
    <table className="data-table table-compact">
      <thead>
        <tr>
          <th scope="col">Regra</th>
          <th scope="col" className="col-group">
            Grupo
          </th>
          <th scope="col" className="col-occ th-num">
            Ocorrências
          </th>
          <th scope="col" className="col-status">
            Status
          </th>
          <th scope="col" className="col-go">
            <span className="sr-only">Ver ocorrências</span>
          </th>
        </tr>
      </thead>
      <tbody>
        {rows.map(({ rule, count }) => (
          <RuleRow
            key={rule.id}
            rule={rule}
            count={count}
            onOpen={onOpenRule}
          />
        ))}
      </tbody>
    </table>
  );
}

export default RuleTable;
